import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { TEST_LOCATORS } from '@src/constants/test-locators'

import { BRAND_LOGO_SIZE, BRAND_LOGO_TYPES } from './BrandLogo.constants'
import styles from './brandLogo.module.scss'
import Logo from './logo.inline.svg'

export interface BrandLogoProps {
  type?: BRAND_LOGO_TYPES
  size?: BRAND_LOGO_SIZE
  className?: string
  srOnlyLabel?: string
  spanClassName?: string
}

export const BrandLogo = ({
  size = BRAND_LOGO_SIZE.LARGE,
  type = BRAND_LOGO_TYPES.SECONDARY,
  className,
  srOnlyLabel,
  spanClassName,
}: BrandLogoProps) => {
  const { t } = useTranslation('accountPage')

  const classNames = classnames(styles[`brand_logo_size__${size}`], styles[`brand_logo_type__${type}`], className)

  return (
    <>
      {/* eslint-disable-next-line */}
      <span className={classnames('sr-only', spanClassName)}>{srOnlyLabel || t('quince')}</span>
      <Logo className={classNames} role="presentation" data-testid={TEST_LOCATORS.BRAND_LOGO} />
    </>
  )
}

export default BrandLogo
